var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.555664 3.5C0.555664 2.5334 1.33906 1.75 2.30566 1.75H12.8057C13.7709 1.75 14.5557 2.5334 14.5557 3.5V10.5C14.5557 11.4652 13.7709 12.25 12.8057 12.25H2.30566C1.33906 12.25 0.555664 11.4652 0.555664 10.5V3.5ZM1.43066 3.5V4.59102L6.7791 8.51211C7.24121 8.85117 7.87012 8.85117 8.33223 8.51211L13.6807 4.59102V3.5C13.6807 3.01602 13.2896 2.625 12.8057 2.625H2.28105C1.8225 2.625 1.40605 3.01602 1.40605 3.5H1.43066ZM1.43066 5.67656V10.5C1.43066 10.984 1.8225 11.375 2.30566 11.375H12.8057C13.2896 11.375 13.6807 10.984 13.6807 10.5V5.67656L8.84902 9.21758C8.07793 9.78359 7.0334 9.78359 6.2623 9.21758L1.43066 5.67656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c797c0416f94a0effe3cf49dd82854cf.svg";
export { ForwardRef as ReactComponent };